import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = (props) => {
  const { children, redirectTo="/login", isAuthenticated } = props;
  return (
    isAuthenticated ? (children ? children : <Outlet />) : <Navigate to={redirectTo} />
  );
};

export default PrivateRoute;